export default "__VITE_ASSET__b8d179b9__"